import { NavLink } from "react-router-dom";
import { Plus } from "lucide-react";
import { cn } from "@/lib/cn";
import { Logo } from "@/components/ui/Logo";
import { navItems } from "./navItems";
import styles from "./Sidebar.module.css";

export function Sidebar({ onQuickAdd }: { onQuickAdd: () => void }) {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.brand}>
        <Logo size={34} className={styles.logo} />
        <span className={styles.brandName}>ControleNext</span>
      </div>

      <button className={styles.quickAdd} onClick={onQuickAdd}>
        <Plus size={17} strokeWidth={2.5} />
        Novo lançamento
      </button>

      <nav className={styles.nav}>
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) => cn(styles.navLink, isActive && styles.navLinkActive)}
          >
            <Icon size={18} strokeWidth={2.2} />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
